<template>
  <div class="login-page">
    <form @submit.prevent="login" v-if="!forgotten">
      <div class="input-style has-icon input-style-1 input-required">
          <i class="input-icon fa fa-user font-11"></i>
          <span>Email</span>
          <em>(required)</em>
          <input type="email" placeholder="email" v-model="email"/>
      </div>
      <div class="input-style has-icon input-style-1 input-required">
          <i class="input-icon fa fa-lock font-11"></i>
          <span>Password</span>
          <em>(required)</em>
          <input type="password" placeholder="Password" v-model="password"/>
      </div>
      <p class="feedback">{{ feedback }}</p>
      <div class="clear"></div>
      <div class="center-allign">
          <ui-button color="green" :loading="loading" >Login</ui-button>
      </div>
    </form>
    <form @submit.prevent="resetPassword" v-else>
      <div class="input-style has-icon input-style-1 input-required">
          <i class="input-icon fa fa-user font-11"></i>
          <span>Email</span>
          <em>(required)</em>
          <input type="email" placeholder="email" v-model="email"/>
      </div>
      <p class="feedback">{{ feedback }}</p>
      <div class="clear"></div>
      <div class="center-allign">
          <ui-button color="red" :loading="loading" >Reset Password</ui-button>
      </div>
    </form>
    <div class="divider"></div>
    <ui-button type="secondary" @click="forgotten = true" v-if="!forgotten">Reset Password</ui-button>
    <ui-button type="secondary" @click="forgotten = false" v-else>Back</ui-button>

  </div>
</template>

<script>
import * as firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
//import 'firebase/storage'

export default {
  name: 'LoginForm',
  data () {
    return {
      email: null,
      password: null,
      feedback: null,
      loading: false,
      forgotten: false
    }
  },
  methods: {
    resetPassword(){
      firebase.auth().sendPasswordResetEmail(this.email)
      .then(() => {
        this.feedback = "You'll shortly receive an email to reset your password"
      }).catch(err => {
        this.feedback = err.message
      })
    },
    async login(){
      if(this.email && this.password){
        this.loading = true
        this.feedback = null
        firebase.auth().signInWithEmailAndPassword(this.email, this.password)
        .then(cred => {
          return firebase.firestore().collection('users').doc(cred.user.uid).get()
        }).then(doc => {
          const userObj = doc.data()
          userObj.uid = doc.id
          localStorage.setItem('user', JSON.stringify(userObj))
          return true
        }).then(() => {  
            this.loading = false
            this.$router.push({ name: 'Home' })
        }).catch(err => {
          this.loading = false
          this.feedback = err.message
        })
      } else {
          this.feedback = 'Please fill in both fields'
      }
    },

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.feedback {
  text-align: center;
  color: red;
}

.login-submit{
  background-color: #8CC152!important;
  color: #FFFFFF!important;
}



</style>
